<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">平台名称</div>
            <el-input v-model="listQuery.PlatformName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>资料模板</el-breadcrumb-item> -->
          <el-breadcrumb-item>招投标网站</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div style="margin-bottom: 10px;float: right;">
          <el-button type="success" size="small" @click="addWeb('')">&nbsp;新增</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" style="width: 1031px;">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="PlatformName" label="平台名称" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="WebsiteUrl" label="网址" width="200" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <div class="j_url_txt" title="点击即可转跳至该网站" @click="openWeb(scope.row.WebsiteUrl)">{{ scope.row.WebsiteUrl }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="RegisterName" label="注册主体" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AccountManager" label="账号管理员" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.AccountManagerid)" v-show="row.AccountManagerid && row.AccountManager" title="点击查看联系方式">{{row.AccountManager}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="BiddingManager" label="投标文件管理员" width="120" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.BiddingManagerid)" v-show="row.BiddingManagerid && row.BiddingManager" title="点击查看联系方式">{{row.BiddingManager}}</span>
              </el-popover>
            </template>
          </el-table-column> -->
          <el-table-column prop="Remark" label="备注" width="300" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark" label="操作" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" @click="addWeb(scope.row)">编辑</span>
              <span class="info_item_sys cp" style="margin-left: 10px;" @click="del(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        tableHeight: 0,
        listQuery: {
          PlatformName: '', //平台，吃
          pageNum: 1,
          pageSize: "10"
        },
        totalCount: 0,
        tableData: [{
          name: 'aaa',
          address: 'adsad'
        }],
        gridData:[],//联系方式表格
        gridloading:false
      };
    },
    created() {
      this.calHeight();
      this.getBiddingwebsiteList();
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      getBiddingwebsiteList() {
        xz.getBiddingwebsiteList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getBiddingwebsiteList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getBiddingwebsiteList();
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      searchHandle() {
        this.getBiddingwebsiteList()
      },
      //查看详情
      toDdetail() {
        this.$router.push({
          path: '/legalSubjectInfo'
        })
      },
      addWeb(row) {
        this.$router.push({
          path: "/addWeb",
          query: {
            row: row ? JSON.stringify(row) : ''
          },
        });
        // window.open(routerUrl.href, "_blank");
      },
      del(row) {
        this.$set(row, 'IsDeleted', 1)
        xz.updateBiddingwebsite(row).then(res => {
          if (res.status == 'ok') {
            this.getBiddingwebsiteList()
            this.$message.success('删除成功')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      openWeb(url){
        if(url.indexOf('http')>-1){
          window.open(url, '_blank');
        }else{
          window.open('https://' + url, '_blank');
        }
      },
      getPhone(id){
        this.gridData = [];
        this.gridloading = true;
        xz.getJbUserDetail(id).then(res=>{
          if(res.status=='ok'){
            this.gridData = [{
              phone:res.msg.Strmobile
            }]
            this.gridloading = false;
          }else{
            this.$message.error('获取联系方式失败')
            this.gridData = [];
            this.gridloading = false;
          }
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
  .j_url_txt{
    text-decoration: underline;
    cursor: pointer;
  }
</style>
<style>
  .page_israGud .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_israGud .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_israGud .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_israGud .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_israGud .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_israGud .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_israGud .screenInputs .screenInput .el-select .el-input__inner,
  .page_israGud .re_down_form.el-form--inline .el-form-item__content,
  .page_israGud .re_down_form .el-select,
  .page_israGud .re_down_form .el-form-item__content,
  .page_israGud .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_israGud .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_israGud .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_israGud .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>